import { LOGIN_TYPE } from '../../assets/data/common';
import axiosBasicInstance from '../../axios/axiosConfig';

export const getUrlWithoutProtocol = () => {
   const currentURL = window.location.href;
   const url = new URL(currentURL);
   return url.origin.replace(/^(https?:\/\/)/, '');
};

export function setAccessToken(access = '', type = 'normal') {
   localStorage.setItem('type', type);
   localStorage.setItem('access', access);
}

export function getAccessToken() {
   return localStorage.getItem('access') ?? '';
}
export function getTypeAccessToken() {
   return localStorage.getItem('type') ?? LOGIN_TYPE.normal;
}

export function removeAccessToken() {
   localStorage.removeItem('type');
   localStorage.removeItem('access');
}

export const generateRandomString = () => {
   const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
   let randomString = '';
   for (let i = 0; i < 6; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      randomString += characters.charAt(randomIndex);
   }

   console.log('Generated Random String:', randomString); // Log the generated string for debugging

   return randomString;
};

export const generateRandomString4Key = (prefix) => {
   const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
   let randomString = '';
   for (let i = 0; i < 4; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      randomString += characters.charAt(randomIndex);
   }
   let finalEmployCode;
   if (prefix) {
      finalEmployCode = prefix + randomString;
   } else {
      finalEmployCode = randomString;
   }

   return finalEmployCode;
};

export function setHeaderCompanyId(companyId) {
   axiosBasicInstance.defaults.headers.common['companyId'] = companyId;
}

export function createQueryParams(value) {
   return new URLSearchParams(value);
}

export function generateTranslateMuiTable(t) {
   return {
      // ===== Columns Management (v7/v8) =====
      columnsManagementSearchTitle: t('common.search'),
      columnsPanelShowAllButton: t('common.content-056'),
      columnsPanelHideAllButton: t('common.content-055'),
      columnsPanelResetButton: t('button.reset'),

      // ===== Toolbar =====
      toolbarColumns: t('common.content-052'),
      toolbarFilters: t('common.content-053'),
      toolbarDensity: t('common.content-054'),

      toolbarDensityCompact: t('common.content-069'),
      toolbarDensityStandard: t('common.content-070'),
      toolbarDensityComfortable: t('common.content-071'),

      toolbarQuickFilterPlaceholder: t('common.search'),

      // ===== Filter Panel =====
      filterPanelColumns: t('common.content-052'),
      filterPanelOperator: t('common.content-059'),
      filterPanelInputLabel: t('common.content-067'),
      filterPanelInputPlaceholder: t('common.content-068'),

      filterOperatorContains: t('common.content-060'),
      filterOperatorEquals: t('common.content-061'),
      filterOperatorStartsWith: t('common.content-062'),
      filterOperatorEndsWith: t('common.content-063'),
      filterOperatorIsEmpty: t('common.content-064'),
      filterOperatorIsNotEmpty: t('common.content-065'),
      filterOperatorIsAnyOf: t('common.content-066'),
      filterOperatorDoesNotContain: t('common.content-190'),
      filterOperatorDoesNotEqual: t('common.content-191'),

      // ===== Column menu =====
      columnMenuSortAsc: t('common.content-072'),
      columnMenuSortDesc: t('common.content-073'),
      columnMenuFilter: t('common.content-074'),
      columnMenuHideColumn: t('common.content-075'),
      columnMenuManageColumns: t('common.content-076'),
      columnMenuUnsort: t('common.content-143'),

      // ===== Empty states =====
      noRowsLabel: t('common.no-data'),
      noResultsOverlayLabel: t('common.no-result-found'),

      footerRowSelected: (count) =>
         t('common.row-selected', { count }),
   };
}

export function generateTranslateMuiPicker(t) {
  return {
    cancelButtonLabel: t("button.cancel"),        // Hủy
    okButtonLabel: t("button.ok"),                // Đồng ý
    clearButtonLabel: t("button.clear"),

    datePickerToolbarTitle: t("common.select-date"),
    timePickerToolbarTitle: t("common.select-time"),
    dateTimePickerToolbarTitle: t("common.duration"),

    toolbarTitle: t("common.duration"),
  };
}
